export const INVOICE_V2_STATUS = [
  'waiting_for_parsing',
  'parsing',
  'waiting_for_checking',
  'checking',
  'manual_validation',
] as const;

export const INVOICE_V2_RESULT_STATUS = [
  'open',
  'completed',
  'rejected',
] as const;

export const INVOICE_V2_SOURCE = [
  'email',
  'user_upload',
  'mobile_app_upload',
  'api',
  'test',
] as const;
